export const demoJa = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': '今すぐプレイ — Grymwyrdへ降りる',
  'demo.seoDescription':
    '世界を回転させ、テーブルに着席し、Grymwyrdの英雄を創造し、骨を転がす — Grymwyrd仮想卓上ゲームの案内ツアー。',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Grymwyrdの世界',
  'demo.globe.spinningWorld': '世界を回転中…',
  'demo.globe.tagline': '生きた恐怖ファンタジーの世界',
  'demo.globe.arrivedHeading': 'グレイウィック地域',
  'demo.globe.heading': '永遠の薄暮の中で場所を見つけよう',
  'demo.globe.subheading': '世界の中心にテーブルが待っている。着席して英雄を創造しよう。',
  'demo.globe.enterCta': 'Grymwyrdへ降りる',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': '物語の一部になる',
  'demo.account.subheading':
    '無料アカウントを作成して、Grymwyrd百科事典全体のロックを解除し、これから創造する英雄を保存するか、ゲストとして通り抜けて今すぐ探索してください。',
  'demo.account.createAccount': 'アカウントを作成',
  'demo.account.logIn': 'ログイン',
  'demo.account.continueAsGuest': 'ゲストとして続行',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability}（3d6）',
  'demo.create.initiativeLabel': 'イニシアチブ',
  'demo.create.lobbyEyebrow': 'Grymwyrd仮想卓上ゲーム · ロビー',
  'demo.create.heading': '英雄を創造する',
  'demo.create.subheading': 'SRD 5.2.1のキャラクター、Grymwyrdから生まれた。名前を付け、職業を選び、骨を転がす。',
  'demo.create.nameLabel': '名前',
  'demo.create.namePlaceholder': '彼らは何になるのか？',
  'demo.create.chooseCalling': '職業を選択',
  'demo.create.keyAbility': 'キー：{ability}',
  'demo.create.abilityScores': '能力値',
  'demo.create.abilityScoresHint': '— クリックして3d6を振る',
  'demo.create.rollAbilityAria': '{ability}を振る（3d6）',
  'demo.create.keepStandard': 'または標準の10を保つてそのまま始める。',
  'demo.create.initiativeResult': 'イニシアチブ {initiative} — 骨を転がし、テーブルがあなたを向く…',
  'demo.create.bonesTumble': '骨が転がる…',
  'demo.create.rollInitiativeCta': 'イニシアチブで振って着席する',
  'demo.create.chooseCallingHint': '着席するために職業を選択してください。',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'テーブルが設定できませんでした',
  'demo.table.errorBody': '仮想卓上ゲームは現在利用できません。',
  'demo.table.browseLiveTables': '代わりにアクティブなテーブルを閲覧',
  'demo.table.settingTable': 'テーブルを設定中…',
  'demo.table.connecting': '卓上ゲームに接続中…',
  'demo.table.heroTable': '{name}のテーブル',
  'demo.table.firstTable': 'あなたの最初のテーブル',
  'demo.table.diceTrayHeading': 'ダイストレイ',
  'demo.table.initiativeHeading': 'イニシアチブ',
  'demo.table.initiativePrompt': '骨を転がして戦闘の順序を決める。',
  'demo.table.rollForInitiative': 'イニシアチブで振る',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'ゲームを一時停止、匿名で',
  'demo.table.xcard': 'X-カード',
  'demo.table.saveHeroTitle': '英雄を保存するために無料アカウントを作成',
  'demo.table.saveHero': '英雄を保存',
  'demo.table.statusLive': 'ライブ',
  'demo.table.statusConnecting': '接続中',
  'demo.table.actionLogHeading': 'アクションログ',
  'demo.table.recentRollsHeading': '最近のロール',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': '英雄シート',
  'demo.panel.companion': 'コンパニオン',
  'demo.panel.diceTray': 'ダイストレイ',
  'demo.panel.macros': 'マクロ',
  'demo.panel.diceConsole': 'ダイスコンソール',
  'demo.panel.initiative': 'イニシアチブ',
  'demo.panel.poll': '投票',
  'demo.panel.recentRolls': '最近のロール',
  'demo.panel.reference': 'リファレンス',
  'demo.panel.chat': 'チャット',
  'demo.panel.handouts': 'ハンドアウト',
  'demo.panel.safety': '安全',
  'demo.panel.sceneAndCues': 'シーン & キュー',
  'demo.panel.replay': 'リプレイ',
  'demo.panel.recap': 'リキャップ',
  'demo.panel.actionLog': 'アクションログ',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': '近接',
  'demo.action.cast': 'キャスト',
  'demo.action.move': '移動',
  'demo.action.block': 'ブロック',
  'demo.action.chooseTarget': '{action}のターゲットを選択…',
  'demo.action.controlling': '操作中：',
  'demo.action.cannotAct': '{label}は行動できません — モブ、プレイヤー、ビークル、またはNPCを選択してください。',
  'demo.action.selectActionable': '行動できるオブジェクトを選択してください。',
  'demo.action.cancel': 'キャンセル',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': '順序をロール中…',
  'demo.tracker.combatant': '戦闘員 {n}',
  'demo.tracker.previousTurn': '前のターン',
  'demo.tracker.round': 'ラウンド {round}',
  'demo.tracker.endCombatTitle': '戦闘を終了',
  'demo.tracker.end': '終了',
  'demo.tracker.nextTurnTitle': '次のターン',
  'demo.tracker.next': '次へ',
  'demo.tracker.hitPoints': 'ヒットポイント',
  'demo.tracker.reduceHp': '{name}のHP を低下',
  'demo.tracker.raiseHp': '{name}のHP を上昇',
  'demo.tracker.addStatusEffect': 'ステータス効果を追加',
  'demo.tracker.removeFromOrder': '順序から削除',
  'demo.tracker.removeFromOrderTitle': '順序から削除',
  'demo.tracker.removeCondition': '{name}を削除',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'テーブルは一時停止中です',
  'demo.xcard.heading': 'テーブルは一時停止中です',
  'demo.xcard.body':
    '誰かがX-カードを上げました。質問なし、誰もが指名されないまま一時停止します。皆さんが準備できたら、続行してください。',
  'demo.xcard.resume': '準備完了 — 再開',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'ハンドアウト',
  'demo.handouts.titlePlaceholder': 'タイトル（オプション）',
  'demo.handouts.bodyPlaceholder': 'メモ、手がかり、読み上げ用…',
  'demo.handouts.push': 'テーブルにプッシュ',
  'demo.handouts.whispered': 'ささやかれた',
  'demo.handouts.dismiss': 'ハンドアウトを却下',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': '安全',
  'demo.safety.description': '越えない線、引く覆い。テーブル全体で共有され、決して帰属しない。',
  'demo.safety.linesLabel': 'ライン（絶対ダメ）',
  'demo.safety.veilsLabel': 'ベール（黒くフェード）',
  'demo.safety.removeItem': '「{item}」を削除',
  'demo.safety.addLinePlaceholder': 'ラインを追加…',
  'demo.safety.addVeilPlaceholder': 'ベールを追加…',
  'demo.safety.addLine': 'ラインを追加',
  'demo.safety.addVeil': 'ベールを追加',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': '英雄シート',
  'demo.sheet.hp': 'HP',
  'demo.sheet.ac': 'AC',
  'demo.sheet.classLevel': '{className} · Lv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'コンパニオンデバイス',
  'demo.companion.description':
    'スマートフォンまたはタブレットを読み取り専用の2番目の画面としてペアリング — イニシアチブ、最近のロール、シーンはデバイスに反映されます。いつでも取り消すことができます。',
  'demo.companion.pairDevice': 'デバイスをペアリング',
  'demo.companion.qrAriaLabel': 'コンパニオンペアリングQRコード',
  'demo.companion.copied': 'コピーしました',
  'demo.companion.copyLink': 'リンクをコピー',
  'demo.companion.revoke': '取り消す',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'ダイスマクロ',
  'demo.macros.dismissError': 'エラーを却下',
  'demo.macros.newMacro': '新しいマクロ',
  'demo.macros.namePlaceholder': '名前（ドットなし）',
  'demo.macros.labelPlaceholder': 'ボタンラベル（オプション）',
  'demo.macros.save': 'マクロを保存',
  'demo.macros.noDots': 'マクロ名にドットは含まれません。',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': '投票',
  'demo.poll.questionPlaceholder': 'テーブルに質問…',
  'demo.poll.optionPlaceholder': 'オプション {n}',
  'demo.poll.removeOption': 'オプション {n}を削除',
  'demo.poll.addOption': 'オプションを追加',
  'demo.poll.openPoll': '投票を開く',
  'demo.poll.live': 'ライブ',
  'demo.poll.closed': '投票終了',
  'demo.poll.vote': '投票',
  'demo.poll.closePoll': '投票を閉じる',
  'demo.poll.startNewPoll': '新しい投票を開始',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'セッションのリキャップ',
  'demo.recap.tagline': 'あなたのテーブルの物語、塵が落ち着いた時。',
  'demo.recap.gathering': '物語を収集中…',
  'demo.recap.getRecap': 'セッションのリキャップを取得',
  'demo.recap.notableRolls': '注目のロール',
  'demo.recap.copied': 'コピーしました！',
  'demo.recap.share': 'シェア',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'リファレンス',
  'demo.reference.searchPlaceholder': 'モンスター、スペル、ルールを検索…',
  'demo.reference.searchAria': 'シェアする百科事典を検索',
  'demo.reference.typeToSearch': '生きた百科事典を検索するには、少なくとも2文字を入力してください。',
  'demo.reference.searching': '検索中…',
  'demo.reference.open': '{title}を開く',
  'demo.reference.share': 'シェア',
  'demo.reference.dismiss': 'リファレンスを却下',
  'demo.reference.backToSearch': '検索に戻る',
  'demo.reference.loadingContent': 'コンテンツを読み込み中…',
  'demo.reference.notOwned':
    'このブックをまだ所有していません。ライブラリに追加すると、完全なリファレンスのロックが解除されます。',
  'demo.reference.contentDown': 'コンテンツは現在利用できません。少しの間、もう一度お試しください。',
  'demo.reference.noAdditionalContent': 'このリファレンスに追加のコンテンツはありません。',
  'demo.reference.noLinkedContent': 'このリファレンスにリンクされたブックコンテンツがありません。',
  'demo.reference.shareToTable': 'テーブルにシェア',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'リプレイ',
  'demo.replay.tagline': 'セッションをビート毎に遡ります。',
  'demo.replay.loading': '読み込み中…',
  'demo.replay.loadReplay': 'リプレイを読み込む',
  'demo.replay.loadMore': 'もっと読み込む',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'ダイス',
  'demo.dice.dismissError': 'エラーを却下',
  'demo.dice.labelPlaceholder': 'アタック（オプション）',
  'demo.dice.roll': 'ロール',
  'demo.dice.rolledForReal': '本当にロールしました',
  'demo.dice.totalPlaceholder': '合計（必須）',
  'demo.dice.physNotationPlaceholder': '1d20+5（オプション）',
  'demo.dice.physLabelPlaceholder': 'ラベル（オプション）',
  'demo.dice.logPhysical': '物理ロールをログ',
  'demo.dice.onTable': '🎲 テーブル上',
  'demo.dice.private': 'プライベート',
  'demo.dice.public': 'パブリック',
  'demo.dice.rolledPrivately': 'プライベートにロール',
  'demo.dice.exploded': '爆発',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'シーン & キュー',
  'demo.scene.current': 'シーン：{scene}',
  'demo.scene.cueSuffix': '— キュー：{cue}',
  'demo.scene.noScene': 'シーンが設定されていない',
  'demo.scene.oneShotCues': 'ワンショットキュー',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} at {x},{y}',
  'demo.map.tile': 'タイル {x},{y}',
  'demo.map.fogged': 'フォグ処理',
  'demo.map.battleMap': 'バトルマップ',
  'demo.map.gm': 'GM',
  'demo.map.noMap': 'マップなし',
  'demo.map.uploadedMap': 'アップロードされたマップ',
  'demo.map.uploadTitle': 'マップ画像をキャンバスの背景としてアップロード',
  'demo.map.reading': '読み込み中…',
  'demo.map.upload': 'アップロード',
  'demo.map.size': 'サイズ',
  'demo.map.shrinkMap': 'マップを縮小',
  'demo.map.growMap': 'マップを拡大',
  'demo.map.widthShort': 'W',
  'demo.map.narrowMap': 'マップを狭める',
  'demo.map.widenMap': 'マップを広げる',
  'demo.map.heightShort': 'H',
  'demo.map.shortenMap': 'マップを短くする',
  'demo.map.heightenMap': 'マップを高くする',
  'demo.map.fitTitle': 'ポジションをリセット + グリッドを満たすように拡大',
  'demo.map.fit': 'フィット',
  'demo.map.lock': 'ロック',
  'demo.map.adjust': '調整',
  'demo.map.fogOn': 'フォグ ON — クリックして無効にする',
  'demo.map.fogOff': 'フォグ OFF — クリックして有効にする',
  'demo.map.fog': 'フォグ',
  'demo.map.exitPaintTitle': 'ペイントモードを終了',
  'demo.map.paintTitle': 'フォグをペイント — セルをクリックまたはドラッグして表示/非表示にする',
  'demo.map.exitPaint': 'ペイントを終了',
  'demo.map.paint': 'ペイント',
  'demo.map.hexGridTitle': 'ヘックスグリッド — クリックして正方形',
  'demo.map.squareGridTitle': '正方形グリッド — クリックしてヘックス',
  'demo.map.hex': 'ヘックス',
  'demo.map.zoomOut': 'ズームアウト',
  'demo.map.zoomLevel': 'ズームレベル',
  'demo.map.zoomIn': 'ズームイン',
  'demo.map.resetView': 'ビューをリセット',
  'demo.map.reset': 'リセット',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': '{title}を展開',
  'demo.dock.collapse': '{title}を折りたたむ',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': 'テーブルを離れる？',
  'demo.leave.heading': 'テーブルを離れる？',
  'demo.leave.body':
    'ゲームの途中です。これはゲストテーブルです — 今離れると、セッションが終了し、英雄が失われます。',
  'demo.leave.stay': 'テーブルに留まる',
  'demo.leave.leaveAnyway': 'とにかく離れる',
}
